export const unsolicitedApplicationSuffix: Record<string, string> = {
	da: 'uopfordret-ansoegning',
	en: 'unsolicited-application',
	'kl-gl': 'Nammineerluni-qinnuteqaat',
};
